import React, { ReactNode, useMemo, useState } from 'react';
import { Toast, ToastContext } from '@components/toasts/toast-context';

export const ToastProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [toastsToDisplay, setToastsToDisplay] = useState<Toast[]>([]);
  const [toastCounter, setToastCounter] = useState<number>(0);

  const state = useMemo(() => {
    const removeToast = (id: number) => {
      setToastsToDisplay((toastsToDisplay) =>
        toastsToDisplay.filter((toast) => toast.id !== id),
      );
    };

    const addToast = (toast: Omit<Omit<Toast, 'id'>, 'onClose'>) => {
      const newToast = {
        ...toast,
        id: toastCounter,
        onClose: () => {
          removeToast(toastCounter);
        },
      };
      setToastCounter(toastCounter + 1);
      setToastsToDisplay([...toastsToDisplay, newToast]);
      return newToast.id;
    };

    const addToasts = (toasts: Omit<Omit<Toast, 'id'>, 'onClose'>[]) => {
      const newToasts = toasts.map((toast, index) => ({
        ...toast,
        id: toastCounter + index,
        onClose: () => {
          removeToast(toastCounter + index);
        },
      }));
      setToastCounter(toastCounter + newToasts.length);
      setToastsToDisplay([...toastsToDisplay, ...newToasts]);
      return newToasts.map((element) => element.id);
    };

    return {
      toasts: toastsToDisplay,
      addToast: addToast,
      addToasts: addToasts,
      removeToast: removeToast,
    };
  }, [toastCounter, toastsToDisplay]);

  return (
    <ToastContext.Provider value={state}>{children}</ToastContext.Provider>
  );
};
